import React from "react";
import { NavLink } from "react-router-dom";

const CharactersList = ({ characters, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Characters</p>

      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/characters/overview`}
            activeClassName="is-active">
            Overview
          </NavLink>
        </li>
        <hr />
        {(characters || []).map((character, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/characters/${character.id}/edit`}
                activeClassName="is-active"
                title={character.name}
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/characters/${character.id}/`
                  );
                }}>
                {character.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default CharactersList;
